document.addEventListener('DOMContentLoaded', function () {
  // Select the required elements
  const prevButton = document.querySelector('.slider-button--prev');
  const nextButton = document.querySelector('.slider-button--next');
  const slides = document.querySelectorAll('.grid__item.slider__slide');
  const thumbnails = document.querySelectorAll('.thumbnail-list__item'); // Thumbnail items
  let currentSlideIndex = 0;

  // Function to update active slide
  function updateSlides() {
    slides.forEach((slide, index) => {
      slide.classList.remove('is-active');
      if (index === currentSlideIndex) {
        slide.classList.add('is-active');
      }
    });
  }

  // Function to update active thumbnail
  function updateThumbnails() {
    thumbnails.forEach((thumbnail, index) => {
      thumbnail.classList.remove('active'); // Remove active from all
      if (index === currentSlideIndex) {
        thumbnail.classList.add('active'); // Add active to the current thumbnail
      }
    });
  }

  // Navigate to the previous slide
  function goToPreviousSlide() {
    if (currentSlideIndex > 0) {
      currentSlideIndex--;
    } else {
      currentSlideIndex = slides.length - 1;
    }
    updateSlides();
    updateThumbnails(); // Update the active thumbnail as well
  }

  // Navigate to the next slide
  function goToNextSlide() {
    if (currentSlideIndex < slides.length - 1) {
      currentSlideIndex++;
    } else {
      currentSlideIndex = 0;
    }
    updateSlides();
    updateThumbnails(); // Update the active thumbnail as well
  }

  // Event listeners for prev and next buttons
  prevButton.addEventListener('click', goToPreviousSlide);
  nextButton.addEventListener('click', goToNextSlide);

  // Add event listeners for thumbnails to change slide and highlight active thumbnail
  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener('click', function () {
      currentSlideIndex = index; // Set currentSlideIndex based on clicked thumbnail
      updateSlides(); // Update the slide to the clicked thumbnail's slide
      updateThumbnails(); // Update the active thumbnail
    });
  });

  // Initialize slider
  updateSlides(); // Set the initial slide to be active
  updateThumbnails(); // Set the initial active thumbnail
});
